import { enUS, sv } from 'date-fns/locale'

export const LOCALES: Record<'en' | 'sv', Locale> = {
  en: enUS,
  sv: sv
}
